/* eslint-disable @repo/internal/react/require-jsdoc */
import { createContext } from 'react';
export const TabContext = /*#__PURE__*/createContext(null);
export const TabListContext = /*#__PURE__*/createContext(null);
export const TabPanelContext = /*#__PURE__*/createContext(null);